import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { InputAdornment, IconButton, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const FPasswordField: React.FC<FBasicPropos> = ({
    field,
    control,
    errors, 
    errorMessage
}) => {
    const { name, editable, icon, inputProps, props, onChange } = field;
    if (!errorMessage) errorMessage = errors[name]?.message as string;
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: controllerField }) => {
                const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    if (onChange) {
                        onChange(event); // Custom onChange logic
                    }
                    controllerField.onChange(event); // Default react-hook-form onChange
                };

                return (
                    <TextField
                        {...controllerField}
                        type={showPassword ? "text" : "password"}
                        label={field.question}
                        variant="standard"
                        margin="normal"
                        fullWidth
                        error={!!errors[name] || !!errorMessage}
                        helperText={errorMessage}
                        disabled={editable === false}
                        placeholder={field.question}
                        InputProps={{
                            startAdornment: icon && (
                                <InputAdornment position="start">
                                    {icon}
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={togglePasswordVisibility}
                                        onMouseDown={(e) => e.preventDefault()}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                            ...inputProps
                        }}
                        {...props}
                        onChange={handleChange}
                        // required={field.required}
                    />
                );
            }}
        />
    );
};
